/**
 * Where sam-dbam lives.
 *
 * Set REACT_APP_DBAM_BASE at build time (cloudbuild). The fallbacks derive it
 * from this page's own address so dev and preview environments still work.
 *
 * This lives in its own file rather than in AuthContext, where it used to be,
 * because the idle clock needs it too. AuthContext imports the idle clock, so
 * the clock cannot import AuthContext back — that is a cycle, and the module
 * that loses the race gets an undefined function at call time.
 */
export function getDbamBase() {
    const envBase =
        (typeof process !== 'undefined' && process.env?.REACT_APP_DBAM_BASE) ||
        '';
    if (envBase) return envBase.replace(/\/+$/, '');
    const origin =
        (typeof window !== 'undefined' && window.location && window.location.origin) ||
        '';
    if (origin.includes('explorer.samsurveyor.com')) {
        return origin.replace('explorer.samsurveyor.com', 'api.samsurveyor.com');
    }
    if (origin.includes('cloudsam-survey-explorer')) {
        return origin.replace('cloudsam-survey-explorer', 'sam-dbam');
    }
    return 'http://localhost:8080';
}

export default getDbamBase;
